import addOrReplaceNotificationMessage from './addOrReplaceNotificationMessage';
import { ApiMethodCallback } from '../ApiMethod';
import { NotificationMessageArgs } from './ExtensibilityNotification';

export default async function replaceNotificationMessageAsyncApiMethod(
    hostItemIndex: string,
    controlId: string,
    data: NotificationMessageArgs,
    callback: ApiMethodCallback
): Promise<void> {
    const result = await addOrReplaceNotificationMessage(
        hostItemIndex,
        controlId,
        data.persistent,
        data.key,
        data.type,
        data.message,
        data.icon,
        false /* noDupes */
    );
    callback(result);
}
